module.exports = __webpack_public_path__ + "static/media/Austria.939724ef.jpg";